class StickyFilterBar {
    constructor() {
        this.options = {
            filtersWrapperSelector: '#main-collection-filters-wrapper',
            filtersHiddenClassName: 'filters-wrapper--hidden',
            filtersFixedClassName: 'filters-wrapper--fixed',
            desktopHeaderHeightVarName: '--header-desktop-height',
            mobileHeaderHeightVarName: '--header-mobile-height',
            mobileNotificationBarHeightVarName: '--notification-bar-mobile-height',
            desktopNotificationBarHeightVarName: '--notification-bar-desktop-height'
        };

        this.headerHeight = 0;
        this.lastScrollY = 0;

        this.init();
    }

    init() {
        this.defineHeaderHeight();
        this.addScrollListener();
    }

    addScrollListener() {
        window.addEventListener("scroll", () => this.handleScroll());
    }

    defineHeaderHeight() {
        const headerMobileHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue(this.options.mobileHeaderHeightVarName));
        const headerDesktopHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue(this.options.desktopHeaderHeightVarName));
        const notificationBarMobileHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue(this.options.mobileNotificationBarHeightVarName)) || 0;
        const notificationBarDesktopHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue(this.options.desktopNotificationBarHeightVarName)) || 0;
        const headerHeight = window.matchMedia("(max-width: 767px)").matches
            ? headerMobileHeight + notificationBarMobileHeight
            : headerDesktopHeight + notificationBarDesktopHeight;

        this.headerHeight = headerHeight
    }

    handleScroll() {
        const filtersWrapper = document.querySelector(this.options.filtersWrapperSelector);
        if (!filtersWrapper) return;

        const filtersWrapperTop = filtersWrapper.getBoundingClientRect().top;
        const currentScrollY = window.scrollY;
        
        if (currentScrollY > this.lastScrollY) {
            filtersWrapper.classList.add(this.options.filtersHiddenClassName);
        } else {
            filtersWrapper.classList.remove(this.options.filtersHiddenClassName);
        }

        this.lastScrollY = currentScrollY;

        if (filtersWrapperTop <= this.headerHeight) {
            filtersWrapper.classList.add(this.options.filtersFixedClassName);
        } else {
            filtersWrapper.classList.remove(this.options.filtersFixedClassName);
        }
    }
}

document.addEventListener("DOMContentLoaded", () => new StickyFilterBar());
